export const environment = {
    
    production: false,
    firebase: {
      apiKey: "AIzaSyCOf1upyWQoSfRnpCb34E9cwZma267IQTM",
      authDomain: "dev-conversell.firebaseapp.com",
      databaseURL: "https://dev-conversell-default-rtdb.europe-west1.firebasedatabase.app",
      projectId: "dev-conversell",
      storageBucket: "dev-conversell.appspot.com",
      messagingSenderId: "126183426343",
      appId: "1:126183426343:web:c12520ff6ba06c1e918102",
      measurementId: "G-G9RG3WCF42"
      },
      amazonSDK: {
        // ClientID: 'amzn1.application-oa2-client.2fbd582c8e6f465fbb9692d02131f66c',
        ClientID: 'amzn1.application-oa2-client.f565a08839c74b12841a92e725440c22',
        //CallbackURL: 'https://localhost:4200/loginsuccess/'
      // CallbackURL: 'https://localhost:4200/signinsuccess/'
      },
      APIEndpoint:"https://admin.conversell.ai/",
      urlFulfilmentGA:'https://us-central1-dev-conversell.cloudfunctions.net/fulfillment',
      urlStartedMessage : 'https://graph.facebook.com/v2.6/me/messenger_profile?' +
      'access_token=EAACOBV7q3Q8BAOss1Rxhm8q5ZCvnmGZAuUHKmmMnOyWMDYDsRhLKn5ReLTUsojYLkZBtXgQcZC8zB1Rp6ZAnHP8u0Hz1ePsdGjLYK4hFMVZC42iD7dQ62auHYPQFQlbiboXHI5usvz1j7yFtWKnnsf11od78iZCPr5u2qzT2C1thwZDZD',
      noProfilePic: 'https://firebasestorage.googleapis.com/v0/b/vertical-mapper-187409.appspot.com/o/utils%2Fnoprofile.png?alt=media&token=eb6c3555-3ea6-4459-8fef-0e5096c8cce1',
      urlFacets : 'https://admin.favizone.com/facets/get-facets',
      updateFacetUrl : 'https://admin.favizone.com/facets/updateFacetsData',
      updateFacetsRankUrl : 'https://admin.favizone.com/facets/updateFacetRanks',
      urlUpdateIntent:'https://us-central1-dev-conversell.cloudfunctions.net/AlexaSmapi/update/intent',
      UpdateIntents:'https://us-central1-dev-conversell.cloudfunctions.net/AlexaSmapi/update/interactionModel',
      CreateInteractionModel:'https://us-central1-dev-conversell.cloudfunctions.net/AlexaSmapi/create/interactionModel',
      deleteIntent:'https://us-central1-dev-conversell.cloudfunctions.net/AlexaSmapi/deleteIntent',
      updateFacetsRankUr : 'https://admin.favizone.com/facets/updateFacetRanks',
      favizoneAccountUrl : 'https://admin.favizone.com/user/signupFromConversell',
      FAVIZONE_HOST: 'https://api.favizone.com',
      FAVIZONE_HOST_WITHOUT_HTTPS: 'api.favizone.com',
      FAVIZONE_END_POINTS: {
        UpdateBillingDataFieldsUrl: "shop/updateBillingDataFields",
        addAccount:"v2/user/add-account",
        addCategory:"/v2/category/add",
        importdata:"api/update-import-data",
        connectFromConverllUrl:"api/conversell"
      },
      FAVIZONE_TOKEN:"RkFWSVpPTkVfUkVNT1RFX1VTRVI6d0NtazRaTidNMkh4KV9SYg==",
      urlRecommender : 'https://us-central1-dev-conversell.cloudfunctions.net/mongoAccess',
      urlPersistentMenu : 'https://graph.facebook.com/v2.6/me/messenger_profile?' ,
      facebookVersion: 'v21.0',
      facebookAppSecretKey: '42976bc0c2b56f87cf4cdd1487ead0ac',   //'20f77101fe89edecf1ccbd99e87d3e7d',
      facebookAppKey: '1105249443543482' ,//'109946392986279',
      stripeClientID:"ca_HMq2wFlqHMxJOoGCqlhG4Rw0yX2J3uzj",
      detectIntentURL:"https://us-central1-dev-conversell.cloudfunctions.net/detectIntent",
      shopifyDevBaseURL:"https://us-central1-devconversell.cloudfunctions.net",
      shopifyProdBaseURL:{
        "google-assistant": "https://us-central1-dev-conversell.cloudfunctions.net/shopifyVoiceNotifications",
        "alexa": " https://us-central1-dev-conversell.cloudfunctions.net/shopifyVoiceNotifications",
        "google-assistantAdvanced": "https://us-central1-dev-conversell.cloudfunctions.net/shopifyGAAdmin",
        "messenger": "https://us-central1-dev-conversell.cloudfunctions.net/shopifyConversationnalNotifications"
      },
      
      freeUserLimit:200,
      shopifyPaths: {
        getCollections: "/getallcollection?shop=",
        install: "shopify?shop=",
        updateEnabledDisableCollection: "updateFiltredCategrory",
        billingCreate: "billing/create",
        billingUpdate: "billing/update",
        billingCancel: "billing/cancel",
        getShippingZones: "/getShippingZones?shop=",
        billingCreateOnUsage: "billing/create/subscription/basedOnUsage"
      },
    
      InteractionModelAlexa: 'https://us-central1-dev-conversell.cloudfunctions.net/AlexaSmapi/create/interactionModel',
      resizeSkillIcon:'https://us-central1-dev-conversell.cloudfunctions.net/resizeSkillIcon/resize',
      detectInteractionModelAlexa: 'https://us-central1-dev-conversell.cloudfunctions.net/AlexaSmapi/detect/interactionModel',
      detectIntentAlexa: 'https://us-central1-dev-conversell.cloudfunctions.net/AlexaSmapi/detectIntent',
      AlexaLoginUrl: 'https://us-central1-dev-conversell.cloudfunctions.net/AlexaSmapi/auth',
      //AlexaLoginUrl: 'https://us-central1-dev-conversell.cloudfunctions.net/alexaAPI/alexaSmapi/auth',
      AlexaCreateSkill: 'https://us-central1-dev-conversell.cloudfunctions.net/AlexaSmapi/create/bot',
     //AlexaCreateSkill: 'https://us-central1-dev-conversell.cloudfunctions.net/alexaAPI/alexaSmapi/create/bot',
      createIntentsAlexa: 'https://us-central1-dev-conversell.cloudfunctions.net/AlexaSmapi/create/intents',
      AlexaAccountLinking: 'https://us-central1-dev-conversell.cloudfunctions.net/AlexaSmapi/create/accountLinking',
    
     urlCreateBot: 'https://us-central1-dev-conversell.cloudfunctions.net/createBotConv',
    urlCloneThemeToshop : 'https://us-central1-dev-conversell.cloudfunctions.net/CloneFromThemeToShop',
    
    
    
    
      stripeBaseURL:"https://us-central1-dev-conversell.cloudfunctions.net/stripeSubscription",
     
        stripePaths: {
          listPlans: "list-pricing",
          listPlansByType:"list-plans-by-type",
          getPrimamryPlansByType:"get-primary-plan-by-type",
          getPlanByID:"get-price-by-id",
      
          install: "shopify?shop=",
          home: "?shop=",
          createCustomer: "create-customer",
          createSubscription: "create-subscription",
      
          createCustomerPortalSession: "create-customer-portal-session",
          upgradeSubscription: "upgrade-subscription",
          cancelSubscription: "cancel-subscription",
          billingSessionUrl: "billing-session-url",
          getPlansByChannalTtype: "/get-plans-by-channal-type",
        },
      
      canals:[
        { name:"Google Assistant",
          id:"google-assistant",
          image:"https://firebasestorage.googleapis.com/v0/b/dev-conversell.appspot.com/o/general%2Fgoogle-assistant.png?alt=media&token=a291850b-9114-4e38-863e-0cab85dd83f2"
        },
        { name:"Facebook Messenger",
          id:"messenger",
          image:"https://firebasestorage.googleapis.com/v0/b/dev-conversell.appspot.com/o/general%2Fmessenger_logo.png?alt=media&token=ef01e683-92ae-411a-96e4-52040e78f83e"
        },
        { name:"Amazon Alexa",
          id:"alexa",
          image:"https://firebasestorage.googleapis.com/v0/b/dev-conversell.appspot.com/o/general%2Falexa.png?alt=media&token=5e097f89-9ae3-4b0f-9e5b-fdb983648429"
        }
      ],
      verifyAuthState:"https://us-central1-dev-conversell.cloudfunctions.net/conversellAuthentification/auth/getway/verify",
      sendEmailApi:"https://us-central1-dev-conversell.cloudfunctions.net/sendEmail",

      actionWithoutConfig:[
        "PAYLOAD_ABANDON_CART",
        "PAYLOAD_BACK_TO_LIST",
        "PAYLOAD_DEFAULT_RESPONSE",
        "PAYLOAD_DELETE_CART",
        "PAYLOAD_DELIVERY_ADRESS",
        "PAYLOAD_FILTER",
        "PAYLOAD_FUNCTIONALITY_NOT_AVAILABLE",
        "PAYLOAD_KEEP_CART",
        "PAYLOAD_OUT_OF_STOCK",
        "PAYLOAD_REPEAT_ORDER",
        "PAYLOAD_REPLAY_INFORMATION",
        "PAYLOAD_TRACK_ORDER",
        "PAYLOAD_SKIP",
        "PAYLOAD_SIGNIN",
        "PAYLOAD_SHOW_OPTIONS",
        "PAYLOAD_SHOW_OPTIONS"
      ],

      ingestKnowledgeBase:"https://dev.ingest.conversell.ai",
      elgenKnowledgeBase: "https://dev.elgen.conversell.ai" , 
      // "https://dev.elgen.conversell.ai" ,
      createFunctionTemplate : "https://us-central1-conversell-pfe.cloudfunctions.net/openAIChat/api/createFunction",
      scheduleCronjobUrl :"https://us-central1-dev-conversell.cloudfunctions.net/scheduleCronjob/start-cron",
      simulationUrl : 'https://us-central1-dev-conversell.cloudfunctions.net/openAIChat/api/simulationModeDebug',
      modelsUrl : 'https://us-central1-dev-conversell.cloudfunctions.net/openAIChat/api/models',
      //similarityUrl:"http://57.128.99.143:8005",
      plansWoocommerceSubscriptionUrl: {
      createSubscriptionUrl : "https://us-central1-prodconversell.cloudfunctions.net/stripeSubscription/create-subscription",
      updateSubscriptionUrl : "https://us-central1-prodconversell.cloudfunctions.net/stripeSubscription/update-subscription",
      cancelSubscriptionUrl: "https://us-central1-prodconversell.cloudfunctions.net/stripeSubscription/cancel-subscription"
      }
}